<app-form-min-configurations></app-form-min-configurations>
<div class="cardList" fxlayoutgap="5px grid">
<ng-template ngFor let-config [ngForOf]="lstConfigurations" let-i="index" >
  <app-configuration-min [configuration]="config" fxFlex="1 1 auto"></app-configuration-min>
</ng-template>
</div>
